import { render } from "./HowToBecomeSection.vue?vue&type=template&id=6c6eeee5&scoped=true"
import script from "./HowToBecomeSection.vue?vue&type=script&lang=js"
export * from "./HowToBecomeSection.vue?vue&type=script&lang=js"

import "./HowToBecomeSection.vue?vue&type=style&index=0&id=6c6eeee5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6eeee5"]])

export default __exports__